<template>
<div>
  <HeadDetailsGama  v-on:save="SalvarPogressao" :btnCanceSave="true" :titleHead="'Detalhe do Empreendimento'"></HeadDetailsGama>
  <div id="body-details" >
    <div id="head-details" class="pt-2">
    </div>
        <b-card no-body class="mb-2 mt-4  w-100 ">
            <b-card-header v-on:click="changeAngel = !changeAngel"  header-tag="header" class=" w-100 h-100 p-0" role="tab">
              <div  v-b-toggle="'teste'" variant="info" class="head-mes">
                <div class="title-left pl-3">
                  <div class="title-colapse-mirror">{{'Evolução da Obra'}}</div>
                </div>
                <div class="componente" style="margin-right: 1rem;">
                <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
                <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
              </div>
              </div>
            </b-card-header>
            <b-collapse :id="'teste'" :accordion="'teste'" role="tabpanel">
              <b-card-body>
                  <div class="Ajuste-Button">
                   <button @click="openEvolucao"  class="btn-new-gru mr-2"><i class="fas fa-plus mr-2"></i>ADICIONAR ETAPA DE EVOLUÇÃO</button>
                </div>
               <div class="classe1">
                    <div v-for="(t,i) in stage" v-bind:key="t.id" class="row-perce pt-4">
                  <div class="title-per">
                    {{i+1}} - {{t.etapaObra.nome}}
                  </div>
                  <div class="d-flex">
                    <button v-on:click="Diminuir(t.id)" class="btn-perce mr-2"><i class="fas fa-minus"></i></button>
                    <b-form-input :value="t.percentualPronto + '%'" :id="'input' + t.id" class="perc-input text-center" v-on:change="changeValor(t.id)" :formatter="formatPercentage"> </b-form-input>
                    <button v-on:click="Aumentar(t.id)" class="btn-perce ml-2"><i class="fas fa-plus"></i></button>
                  </div>
                </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-2 mt-4  w-100 ">
            <b-card-header  header-tag="header" class=" w-100 h-100 p-0 collapse-youtube" role="tab">
              <div  v-on:click="changeAngel2 = !changeAngel2" v-b-toggle="'teste2'" variant="info" class="head-mes w-100">
                <div class="title-left pl-3">
                  <div class="title-colapse-mirror">{{'Imagens da Obra'}}</div>
                </div>
              </div>
              <i  class="fab fa-youtube youtube-icon"
                  style="font-size: 30px; color:red; display: flex; align-items: center;"
                  @click="openLinkYotube()"
                  v-b-tooltip.hover title="Adicionar link do Youtube"></i>
              <div v-on:click="changeAngel2 = !changeAngel2" class="d-flex align-items-center" style="gap: 1rem; margin-right: 1rem">
                <div class="componente w-10">
                  <i v-if="!changeAngel2"  class="fas fa-angle-down arrow-angel" v-b-toggle="'teste2'"></i>
                  <i v-if="changeAngel2" class="fas fa-angle-up arrow-angel" v-b-toggle="'teste2'"></i>
                </div>
              </div>
            </b-card-header>
            <b-collapse :id="'teste2'" v-model="imgobra" :accordion="'teste2'" role="tabpanel">
              <b-card-body>
                <div class="img-flex">
                  <div  v-for="datafor in dataimg" style="padding:0.5rem" v-bind:key="datafor.id">
                    <div class="img-body" v-if="!datafor.arquivo.isLinkYoutube">
                      <button @click="removeEnterpriseArquivo(datafor.id)" class="removed"><i class="fas fa-times-circle"></i></button>
                      <div class="img-title">{{datafor.arquivo.descricao == null ? 'N/D' : datafor.arquivo.descricao }}</div>
                      <img  class="mb-2 img-body-body" :src="'data:image/jpeg;base64,' + datafor.arquivo.arquivo">
                      <div class="img-footer">
                      </div>
                    </div>
                    <div v-else class="img-body" >
                      <button @click="removeEnterpriseArquivo(datafor.id)" class="removed"><i class="fas fa-times-circle"></i></button>
                      <iframe width="100%" height="100%" :src="computedEmbedYoutube(datafor.arquivo.arquivo)"/>
                    </div>
                  </div>
                 <div v-on:click="addIma" style="padding:0.5rem">
                    <div class="imp-arquivo">
                      <div><i class="fas fa-file-import"></i></div>
                      <div class="title-pdf">Adicionar Arquivo</div>
                      <input accept="image/png, image/gif, image/jpeg" @change="saveBuild" type="file" class="addinput" id="input-build">
                    </div>
                 </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
   </div>
   <b-modal
    hide-footer
    centered
    size="md"
    ref="add-link-youtube"
    id="add-link-youtube"
    :title="'Adicionar link do youtube'"
    >
      <template #modal-title>
        <div class="header-title">Adicionar link do youtube</div>
      </template>
    <div class="d-flex justify-content-center mb-4">
      <i class="fab fa-youtube mt-1 mr-2" style="font-size: 80px; color:red" @click="openLinkYotube"></i>
    </div>
    <div class="d-flex justify-content-center">
      <input v-model="linkyoutube" class="form-control" placeholder="Digite um link do youtube">
      <button class="ml-2 btn-plus-yotutube" @click="addLinkYotube">+</button>
    </div>
    <div v-if="liksYoutube.length > 0">
      <div class="d-flex mt-3 flex-wrap imagem-all-yt">
        <div class="body-video mr-1 mb-1" v-for="(data) in liksYoutube" :key="data">
          <button @click="removeLinkYotube(data.id)" class="removed"><i class="fas fa-times-circle"></i></button>
          <iframe width="100%" height="100%" :src="data.link"/>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center margin">
      <button class="mr-2 btn-can" @click="cancelLiksYoutube">CANCELAR</button>
      <button class="ml-2 btn-save" @click="SendLiksYoutube">SALVAR</button>
    </div>
  </b-modal>

  <b-modal
    hide-footer
    centered
    size="md"
    ref="add-evolucao"
    id="add-evolucao"
    :title="'Adicionar Etapa de Evolução'"
   >
             <template #modal-title>
                <div class="header-title">Adicionar Etapa de Evolução</div>
            </template>
    <div class="conteiner-evolucao">
      <div class="d-flex justify-content-center mb-4">
        <i class="fas fa-tools icone-evolucao"></i>
      </div>

      <div>
        <div v-if="criar == false">
          <label class="labelseach">Tipos de Evolução</label>

          <multiselect v-model="TipoEvolucaoArray" :multiple="true" :taggable="true" placeholder="Selecione" :options="obraArray" label="nome" @tag="addTag" track-by="id" :close-on-select="false">
          </multiselect>
        </div>

        <div  v-else>
          <label class="labelseach">Nome do Tipos de Evolução</label>
          <div>
            <input v-model="nomeEvolucao" class="input-details" >
          </div>
        </div>

          <div class="conteiner-criar">
            <button v-if="criar == false" @click="mudarCriacao" class="botton-criar">CRIAR</button>
            <button v-else @click="mudarCriacao"  class="botton-criar">SELECIONAR</button>
          </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <button class="mr-2 btn-can" @click="cancelar">FECHAR</button>
      <button class="ml-2 btn-save" @click="salvar">SALVAR</button>
    </div>
  </b-modal>
</div>
</template>

<script>
import Evolutionwork from './evolutionwork'
export default Evolutionwork
</script>

<style scoped>
.collapse-youtube{
  display: flex;
  flex-direction: row;
}
.margin{
 margin-top: 1rem;
}
.input-details{
    width: 100%;
    height: 35px;
    background-color: 100%;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
    outline: none;
    padding-left: 1rem;
}
.conteiner-criar{
  display: flex;
  justify-content: end;
  padding: 0.5rem 0 0 0;
}
.botton-criar{
  height: 20px;
  width: fit-content;
  background: white;
  font-size: 10px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
  font-family: 'Segoe UI'
}

.botton-criar:hover{
  height: 20px;
  width: fit-content;
  background: #008148;
  font-size: 10px;
  color:  white;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
  font-family: 'Segoe UI'
}
.conteiner-evolucao{
  padding: 0 0 2rem 0;
}
.Ajuste-Button{
    display: flex;
        width: 100%;
    justify-content: initial;
}
.icone-evolucao{
  font-size: 50px;
  color: #008148;
}
.btn-new-gru{
  height: 30px;
  width: fit-content;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}
.btn-new-gru:hover{
  color: white;
  background: #008148;
}
.imp-arquivo{
  width: 270px;
  background-color:white;
  height: 185px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 60px;
  border: 1px dashed  black;

}
.youtube-icon {
  cursor: pointer;
}
.body-video{
  height: 245px;
  width: 245px;
  position: relative;
}
.btn-perce-disa{
  background: #a8a6a6 !important;
}
.perc-input-disa{
  background: #a8a6a6 !important;
}
.title-pdf{
  margin-top: 10px;
  font-size: 24px;
}
.imagem-all-yt{
  min-height: 200px;
  overflow: auto;
  max-height: 60vh;
  justify-content: center;
  border-bottom: 1px solid #D4D4D4;
}

.imagem-all-yt::-webkit-scrollbar-track {
    background-color: #F4F4F4;
}
.imagem-all-yt::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
}
.imagem-all-yt::-webkit-scrollbar-thumb {
    background: #dad7d7;
}

.removed{
  right: 0;
  border: none;
  height: 35px;
  width: 35px;
  font-size: 24px;
  color: white;
  font-weight: bold;
  border-radius: 0 0 10px 10px;
  z-index: 10;
  background: red;
  position: absolute;
}
.btn-can{
  height: 40px;
  width: 25%;
  background: red;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}

.btn-can:hover{
  height: 40px;
  width: 25%;
  background: #be2b2b;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}
.btn-save{
  height: 40px;
  width: 25%;
  background: #008148;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}
.btn-save:hover{
  height: 40px;
  width: 25%;
  background: #008147d7;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}
.classe1{
  display: flex;
  flex-wrap: wrap;
  height: 500px;
  flex-direction: column;
  margin: 10px;
  align-items: center;
}
#body-details-ss{
  height: 30vh;
}
.row-perce{
  display: flex;
  width: 45%;
  justify-content: space-between;
}

.perc-input{
  width: 94px;
  border-radius: 25px;
  outline: none;
  height: 33px;
  border: 1px solid grey;
  background-color: white;
}
.btn-perce{
  border-radius: 50%;
  color: white;
  display: flex;
  margin-top: 5px;
  justify-content: center;
  align-items:center;
  background-color: #008148;
  border: none;
  font-size: 15px;
  width: 25px;
  height: 25px;
}
.btn-plus-yotutube {
  background-color: #008148;
  color: white;
  height: 35px;
  border-radius: 10px;
  font-size: 25px;
  font-weight: bold;
  width: 40px;
  border: none;
}
.btn-remove-yotutube {
  background-color: red;
  color: white;
  height: 35px;
  border-radius: 10px;
  font-size: 25px;
  font-weight: bold;
  width: 40px;
  border: none;
}
.title-per{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}
.col-lst-evolution{
  display: flex;
  flex-direction: column;
}

.head-mes{
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
}

.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.title-colapse-mirror{
  font-weight: bold;
  font-size: 20px;
}

.arrow-angel{
  font-size: 30px;
  color: black;
  cursor: pointer;
}

.componente{
  display: flex;
  font-size: 18px;
  position: relative;
  color: black;
}

.img-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.img-body{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
  cursor: pointer;
}

.img-title{
  color: rgb(255, 255, 255);
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 5;
  align-items: flex-end;
  font-weight: bold;
  width: 270px;
  padding-bottom: 7px;
}

.img-footer{
  position: absolute;
  width: 100%;
  height: 30px;
  background: rgba(0, 0, 0, 0.644);
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.edit-img{
  height: 34px;
  top: 0px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: red;
  border-radius: 0px 8px 0px 15px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}

.addinput{
  height: 100%;
  width: 100%;
  position: absolute;
  visibility: hidden;
}

.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/evolutionwork/evolutionwork.vue